<!-- LOADER (initial, no status yet) -->
<div *ngIf="!status" class="max-w-2xl mx-auto mt-10 text-center">
  <div class="animate-spin rounded-full h-12 w-12 border-4 border-blue-500 border-t-transparent mx-auto"></div>
  <p class="mt-4 text-gray-600">Checking your order status...</p>
</div>

<!-- SUCCESS -->
<div *ngIf="status === 'COMPLETE'"
  class="max-w-2xl mx-auto mt-10 bg-green-50 border border-green-200 rounded-lg p-10 text-center shadow-md">
  <h1 class="text-3xl font-bold text-green-700 mb-4"> {{ textService.getText('apps_confirmation_header') }}
  </h1>
  <p class="text-lg text-gray-700 mb-4">{{ textService.getText('apps_confirmation_statement1') }}
  </p>
  <p class="text-lg text-gray-700 mb-6">{{ textService.getText('apps_confirmation_statement2') }}
  </p>
  <p class="text-sm text-gray-500 italic">{{ textService.getText('apps_confirmation_note') }}
  </p>
  <!-- <div class="mt-6">
    <button (click)="goHome()" class="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300">
      Back to cart
    </button>
  </div> -->
</div>

<!-- ERROR / OTHER STATUSES -->
<div *ngIf="status && status !== 'COMPLETE'"
  class="max-w-2xl mx-auto mt-10 bg-yellow-50 border border-yellow-200 rounded-lg p-8 text-center shadow-md">
  <h1 class="text-3xl font-bold text-yellow-700 mb-4">
    We couldn’t complete your order
  </h1>
  <p class="text-lg text-gray-700 mb-6">
    Something went wrong with your order. Please try again from your cart
    or reach out to support for assistance.
  </p>
  <div class="flex justify-center space-x-4">
    <button (click)="goHome()" class="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300">Back to cart</button>
    <a href="#" class="text-blue-600 underline">Contact support</a>
  </div>
</div>